import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import cn from 'classnames';
import { Spinner } from 'seagull';
import { useOnMount } from '~/hooks/useOnMount';
import styles from './Signature.module.scss';
export default function Signature(param) {
    let { children, className } = param;
    const [loading, setLoading] = useState(true);
    useOnMount(()=>{
        document.fonts.ready.then((fonts)=>{
            // Firefox does not allow destructing FontFaceIterator, so I had to lookup manually
            const allFonts = fonts.values();
            let currentFont;
            while(currentFont = allFonts.next(), !currentFont.done){
                if (currentFont.value.family.includes('AlexBrush-Regular')) {
                    currentFont.value.loaded.then(()=>setLoading(false));
                }
            }
        });
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            loading && /*#__PURE__*/ _jsx(Spinner, {
                size: 40
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.signature, className, {
                    [styles.hidden]: loading
                }),
                "data-testid": "signature",
                children: children
            })
        ]
    });
}
